// extracted by mini-css-extract-plugin
export default {"previewContainer":"UploadImage_previewContainer__+NE7-","previewImage":"UploadImage_previewImage__dHx2R"};